import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "advanced-view page section py-5" }
const _hoisted_2 = { class: "columns content" }
const _hoisted_3 = { class: "column is-9 h-100" }
const _hoisted_4 = {
  key: 0,
  class: "h-100 center"
}
const _hoisted_5 = {
  key: 1,
  class: "h-100 center"
}
const _hoisted_6 = {
  key: 2,
  class: "h-100 center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-database-off is-size-1" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "is-size-5" }
const _hoisted_9 = {
  key: 3,
  ref: "charts",
  class: "charts"
}
const _hoisted_10 = { class: "column is-3 h-100" }
const _hoisted_11 = {
  key: 0,
  class: "box h-100"
}
const _hoisted_12 = {
  key: 1,
  class: "box center h-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_advanced_view_header = _resolveComponent("advanced-view-header")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_chart = _resolveComponent("chart")!
  const _component_n_back_top = _resolveComponent("n-back-top")!
  const _component_station_list = _resolveComponent("station-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_advanced_view_header, { class: "mb-5" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_n_spin, { size: "large" })
            ]))
          : (_ctx.selected.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('advanced_view.please_select_station')), 1 /* TEXT */)
              ]))
            : (!_ctx.indicators || !_ctx.indicators.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('advanced_view.no-data')), 1 /* TEXT */)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicators, (indicator) => {
                    return (_openBlock(), _createBlock(_component_chart, {
                      indicator: indicator,
                      key: indicator.key,
                      stations: _ctx.selected
                    }, null, 8 /* PROPS */, ["indicator", "stations"]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createVNode(_component_n_back_top, {
                    bottom: "100px",
                    right: "28%",
                    to: '.charts'
                  }, null, 8 /* PROPS */, ["to"])
                ], 512 /* NEED_PATCH */))
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.allStations)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_station_list, {
                stations: _ctx.allStations,
                selected: _ctx.selected,
                forgettable: false,
                multiple: true,
                "onStation:forget": _ctx.onStationForgotten
              }, null, 8 /* PROPS */, ["stations", "selected", "onStation:forget"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_n_spin, { size: "large" })
            ]))
      ])
    ])
  ]))
}